/* Little Signals Classroom Check-In (Schools page). Needs ls-rig.js and ls-moves.js first.
   Everything stays in memory. Nothing is saved or sent.
   1. Check in: tap a word for each child. 2. Copy Me: Little Bean leads the move, with a 3-2-1 start,
   other moves to try, a mystery move, and a "check in again" to see the room before and after. */
(function () {
  var root = document.querySelector('[data-ls-cr]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var me = document.currentScript;
  if (me && me.src && !document.getElementById('ls-classroom-css')) {
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.id = 'ls-classroom-css';
    l.href = me.src.replace('ls-classroom.js', 'ls-classroom.css');
    document.head.appendChild(l);
  }

  var WORDS = ['fast', 'heavy', 'tight', 'steady'];
  var NAMES = { fast: 'Fast', heavy: 'Heavy', tight: 'Tight', steady: 'Steady' };
  var MOVES = (window.LSMoves && window.LSMoves.list) || {};
  var counts = { fast: 0, heavy: 0, tight: 0, steady: 0 };
  var before = null;
  var current = 'steady', which = 0, step = -1, timer = null, busy = false;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s) { return root.querySelector(s); }
  function $$(s) { return root.querySelectorAll(s); }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function move() { return MOVES[current][which]; }

  /* ---------- extra pieces added to the page ---------- */
  var stage = $('.ls-cr__stage');
  var steps = $('.ls-cr__steps');
  var from = el('p', 'ls-cr__from'); from.setAttribute('aria-live', 'polite');
  $('[data-move-name]').insertAdjacentElement('afterend', from);
  var goRow = $('.ls-cr__go');
  var another = el('button', 'ls-btn ls-btn--white', 'Another move'); another.type = 'button';
  var mystery = el('button', 'ls-cr__mystery', 'Mystery move'); mystery.type = 'button';
  goRow.appendChild(another);
  var extra = el('div', 'ls-cr__extra'); extra.appendChild(mystery); steps.appendChild(extra);
  var after = el('div', 'ls-cr__after'); after.hidden = true;
  after.appendChild(el('p', 'ls-cr__after-q', 'How does your body feel now?'));
  var again = el('button', 'ls-btn ls-btn--sun', 'Check in again'); again.type = 'button';
  after.appendChild(again); steps.appendChild(after);
  var big = el('div', 'ls-cr__big'); big.setAttribute('aria-live', 'assertive'); big.hidden = true; stage.appendChild(big);
  var leaves = el('div', 'ls-cr__leaves'); leaves.setAttribute('aria-hidden', 'true'); stage.appendChild(leaves);
  var beforeBox = el('div', 'ls-cr__before'); beforeBox.hidden = true;
  beforeBox.appendChild(el('span', 'ls-cr__before-label', 'Before the move'));
  var beforeBar = el('div', 'ls-cr__mix ls-cr__mix--before'); beforeBox.appendChild(beforeBar);
  beforeBox.appendChild(el('span', 'ls-cr__before-label', 'Now'));
  $('.ls-cr__mix').insertAdjacentElement('beforebegin', beforeBox);
  WORDS.forEach(function (w) { var s = el('span'); s.style.background = 'var(--ls-' + w + ')'; s.dataset.before = w; beforeBar.appendChild(s); });

  /* ---------- tabs ---------- */
  function setTab(t) {
    $$('[data-tab]').forEach(function (b) {
      var on = b.dataset.tab === t;
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
    });
    $$('[data-panel]').forEach(function (p) { p.hidden = p.dataset.panel !== t; });
    root.dataset.mode = t;
    if (t !== 'move') stop();
  }
  $$('[data-tab]').forEach(function (b) {
    b.addEventListener('click', function () { setTab(b.dataset.tab); });
    b.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var next = b.dataset.tab === 'class' ? 'move' : 'class';
      setTab(next); root.querySelector('[data-tab="' + next + '"]').focus();
    });
  });

  /* ---------- tally ---------- */
  function total(c) { c = c || counts; return WORDS.reduce(function (a, w) { return a + c[w]; }, 0); }
  function top() {
    var best = [], max = 0;
    WORDS.forEach(function (w) { if (counts[w] > max) { max = counts[w]; best = [w]; } else if (counts[w] === max && max > 0) { best.push(w); } });
    return best;
  }
  function render() {
    var t = total();
    WORDS.forEach(function (w) {
      $('[data-count="' + w + '"]').textContent = counts[w];
      $('[data-bar="' + w + '"]').style.width = t ? (counts[w] / t * 100) + '%' : '0';
    });
    var sum = $('[data-sum]'), go = $('[data-go]'), best = top();
    var lead = before ? 'After the move: ' : '';
    if (!t) {
      sum.textContent = before ? 'Everyone check in again. Has anything changed?' : 'Tap a word each time someone chooses it. Or let children come up and tap their own.';
      go.hidden = true;
    } else if (best.length === 1) {
      sum.textContent = lead + (t === 1 ? '1 check-in so far. ' : t + ' check-ins so far. ') + 'Most of the room feels ' + NAMES[best[0]] + '. Try ' + MOVES[best[0]][0].name + ' together.';
      go.hidden = false; go.dataset.word = best[0];
      go.textContent = 'Do ' + MOVES[best[0]][0].name + ' together';
    } else {
      sum.textContent = lead + t + ' check-ins so far. It’s a mix today: ' + best.map(function (w) { return NAMES[w]; }).join(' and ') + '. Pick one move to do together.';
      go.hidden = false; go.dataset.word = best[0];
      go.textContent = 'Choose a move';
    }
  }
  function floatLeaf(btn) {
    if (reduce) return;
    var f = el('span', 'ls-cr__pop'); btn.appendChild(f);
    setTimeout(function () { f.remove(); }, 1200);
  }
  $$('[data-add]').forEach(function (b) {
    b.addEventListener('click', function () {
      counts[b.dataset.add]++; render(); floatLeaf(b);
      if (!reduce) { b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); }
    });
  });
  $$('[data-minus]').forEach(function (b) {
    b.addEventListener('click', function () { var w = b.dataset.minus; if (counts[w] > 0) { counts[w]--; render(); } });
  });
  $('[data-reset]').addEventListener('click', function () {
    WORDS.forEach(function (w) { counts[w] = 0; }); before = null; beforeBox.hidden = true; render();
  });
  $('[data-hide]').addEventListener('click', function () {
    var on = root.classList.toggle('is-hidden');
    this.setAttribute('aria-pressed', on ? 'true' : 'false');
    this.textContent = on ? 'Show the numbers' : 'Hide the numbers';
  });
  $('[data-go]').addEventListener('click', function () { pick(this.dataset.word || 'steady', 0); setTab('move'); });

  /* ---------- Copy Me ---------- */
  function bean(w, act) { if (window.LSRig) window.LSRig.set($('[data-rig]'), w, act); }
  function clearTimers() { clearTimeout(timer); timer = null; }
  function stop() {
    clearTimers(); busy = false;
    $('[data-play]').textContent = step >= 0 ? 'Start again' : 'Start';
    $('[data-counter]').hidden = true; big.hidden = true;
    root.classList.remove('is-playing');
  }
  function pick(w, n) {
    current = w; which = n || 0; step = -1; stop(); after.hidden = true;
    $$('[data-pick]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.pick === w ? 'true' : 'false'); });
    bean(w, 'none');
    stage.style.setProperty('--ls-cr-tint', 'var(--ls-' + w + '-tint)');
    var m = move();
    $('[data-move-name]').textContent = m.name;
    from.textContent = 'Move ' + (which + 1) + ' of ' + MOVES[w].length + (which ? ' · from ' + m.from : ' · Copy Me');
    var list = $('[data-steps]'); list.innerHTML = '';
    m.steps.forEach(function (s) { list.appendChild(el('li', '', s)); });
    $('[data-play]').textContent = 'Start';
  }
  function show(i) {
    step = i;
    var m = move();
    bean(current, m.acts[i] || 'none');
    $$('[data-steps] li').forEach(function (li, n) {
      li.classList.toggle('is-now', n === i);
      li.classList.toggle('is-done', n < i);
    });
  }
  function countUp(a, b, done) {
    var c = $('[data-counter]'); c.hidden = false; var n = a;
    (function tick() {
      c.textContent = n;
      if (n >= b) { timer = setTimeout(function () { c.hidden = true; done(); }, 1100); return; }
      n++; timer = setTimeout(tick, 1100);
    })();
  }
  function shower() {
    if (reduce) return;
    leaves.innerHTML = '';
    for (var i = 0; i < 14; i++) {
      var f = el('span', 'ls-cr__leaf');
      f.style.left = (4 + Math.random() * 92) + '%';
      f.style.animationDelay = (Math.random() * 0.9).toFixed(2) + 's';
      f.style.setProperty('--r', (Math.random() * 360 | 0) + 'deg');
      f.style.setProperty('--x', ((Math.random() * 80) - 40 | 0) + 'px');
      leaves.appendChild(f);
    }
    setTimeout(function () { leaves.innerHTML = ''; }, 3600);
  }
  function finish() {
    stop(); show(move().steps.length); bean('steady', 'hug');
    $('[data-play]').textContent = 'Do it again';
    after.hidden = false; shower();
  }
  function run(i) {
    var m = move();
    if (i >= m.steps.length) { finish(); return; }
    show(i);
    var next = function () { timer = setTimeout(function () { run(i + 1); }, 900); };
    if (m.count && m.count[0] === i) { countUp(m.count[1], m.count[2], next); }
    else { timer = setTimeout(function () { run(i + 1); }, 3200); }
  }
  function countdown(done) {
    if (reduce) { done(); return; }
    var seq = ['Ready?', '3', '2', '1', 'Copy!'], n = 0;
    big.hidden = false; bean(current, 'together');
    (function tick() {
      if (n >= seq.length) { big.hidden = true; done(); return; }
      big.textContent = seq[n];
      big.classList.remove('is-pop'); void big.offsetWidth; big.classList.add('is-pop');
      n++; timer = setTimeout(tick, n === 1 ? 1100 : 900);
    })();
  }
  $$('[data-pick]').forEach(function (b) { b.addEventListener('click', function () { pick(b.dataset.pick, 0); }); });
  $('[data-play]').addEventListener('click', function () {
    stop(); after.hidden = true; busy = true; root.classList.add('is-playing');
    this.textContent = 'Playing…';
    countdown(function () { run(0); });
  });
  $('[data-next]').addEventListener('click', function () {
    stop(); after.hidden = true;
    var n = step + 1;
    if (n >= move().steps.length) n = 0;
    show(n);
  });
  another.addEventListener('click', function () { pick(current, (which + 1) % MOVES[current].length); });

  /* Mystery move: Little Bean shuffles through the moves and lands on one. */
  mystery.addEventListener('click', function () {
    if (busy) return;
    stop(); after.hidden = true; busy = true;
    var all = [];
    WORDS.forEach(function (w) { MOVES[w].forEach(function (m, n) { all.push([w, n]); }); });
    var land = all[Math.floor(Math.random() * all.length)];
    if (reduce) { busy = false; pick(land[0], land[1]); return; }
    var spins = 12, k = 0;
    root.classList.add('is-shuffling');
    (function spin() {
      var p = k < spins ? all[Math.floor(Math.random() * all.length)] : land;
      pick(p[0], p[1]); busy = true;
      bean(p[0], k < spins ? 'buzz' : 'together');
      k++;
      if (k <= spins) { timer = setTimeout(spin, 80 + k * 18); }
      else { busy = false; root.classList.remove('is-shuffling'); from.textContent = 'Mystery move! ' + from.textContent; }
    })();
  });

  /* Check in again: keep the first check-in as "before" and start a fresh one. */
  again.addEventListener('click', function () {
    if (total()) {
      before = {}; WORDS.forEach(function (w) { before[w] = counts[w]; counts[w] = 0; });
      var t = total(before);
      WORDS.forEach(function (w) { root.querySelector('[data-before="' + w + '"]').style.width = (before[w] / t * 100) + '%'; });
      beforeBox.hidden = false;
    }
    render(); setTab('class');
    var tool = root.closest('section') || root; tool.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  /* ---------- full screen ---------- */
  var fullBtn = $('[data-full]');
  if (!document.fullscreenEnabled) { fullBtn.hidden = true; }
  fullBtn.addEventListener('click', function () {
    if (document.fullscreenElement) { document.exitFullscreen(); } else { root.requestFullscreen().catch(function () {}); }
  });
  document.addEventListener('fullscreenchange', function () {
    root.querySelector('[data-full-label]').textContent = document.fullscreenElement ? 'Exit full screen' : 'Full screen';
  });

  pick('steady', 0); render();
  if (location.hash === '#classroom-move') setTab('move');
})();
